module.exports = {"511303001":"白塔街道","511303002":"清溪街道","511303003":"小龙街道","511303004":"龙门街道","511303005":"青莲街道","511303006":"都京街道","511303008":"老君街道","511303009":"螺溪街道","511303103":"江陵镇","511303104":"擦耳镇","511303106":"东观镇","511303107":"长乐镇","511303108":"胜观镇","511303110":"阙家镇","511303111":"石圭镇","511303112":"青居镇","511303115":"会龙镇","511303117":"走马镇","511303211":"佛门乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511303.json
// module id = 2472
// module chunks = 0